export default ["M14 0h-2v3H4V0H2v4c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V0zM2 16h2v-3h8v3h2v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4z"];
//# sourceMappingURL=page-break.js.map